import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { MatDialogRef } from '@angular/material/dialog';

import { MerklisteService } from '../../services/merkliste.service';
import { ApiService } from '../../services/api.service';
import { JsonExportService } from '../../services/json-export.service';
import { PrintService } from 'src/app/services/print.service';
import { PrintComponent }from '../../print/print.component'
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-merkliste-dialog',
  templateUrl: './merkliste-dialog.component.html',
  styleUrls: ['./merkliste-dialog.component.scss']
})
export class MerklisteDialogComponent implements OnInit {

  documents: any[];
  lang: any;
  mapping: Object;
  idList: string[];

  constructor(
    public merklisteService: MerklisteService,
    private router: Router,
    public http: ApiService,
    public printService: PrintService,
    public jsonExport: JsonExportService,
    public dialogRef: MatDialogRef<MerklisteDialogComponent>,
    public dialog: MatDialog,
    ) {
      this.merklisteService.MessageCount$.subscribe((merklisteCount: number) => {
        this.documents = this.merklisteService.getAllObjects();
      });
    }

  ngOnInit() {
   
    this.lang = 'de-DE';
    this.idList = this.merklisteService.getItemIds();
    console.log(this.idList);
    this.documents = this.merklisteService.getAllObjects();
    console.log( ' this.documents = ', this.documents);
  }

  public onInfoRequest(documentId: string) {
    console.log(documentId);
    this.router.navigateByUrl('/' , {skipLocationChange: true}).then(() =>
    this.router.navigate(['/document/' + documentId]));
    this.dialogRef.close();
  }





  printDocs(): void {
    this.router.navigate(['/print']);
    this.dialogRef.close();
  }
  



  download() {
    this.http.getMapping().subscribe(data => {
      this.mapping = data;
        this.jsonExport.json2output(this.documents, this.mapping, this.lang);
    });
  }



}
